import {
    LISTAR_CATTIPOINTERCONSULTA,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CATTIPOINTERCONSULTA:
            return{
                ...state, 
                tipoInterconsultas: action.payload
            }
        default:
            return state
    }
        
}